import React, { useContext } from 'react';
import PropTypes from 'prop-types';
import classNames from 'classnames';
import { createUseStyles } from 'react-jss';
import { ThemeContext } from 'styled-components';

import { Typography } from '@comparethemarketau/manor-typography';

import { ProviderLogo } from '../common/provider_logo';
import { ComparePill } from '../common/compare_pill';
import { withQuoteFlatten } from '../common/with_quote_flatten';
import { ProductUnderwritten } from '../common/product_underwritten';

const useStyles = createUseStyles((theme) => ({
    container: {
        display: 'flex',
        flexDirection: 'row',
        alignItems: 'center',
        justifyContent: 'flex-start',
        marginBottom: theme.spacing[12]
    },
    product: {
        flexGrow: 1,
        marginRight: theme.spacing[52]
    },
    logo: {
        marginRight: theme.spacing[24]
    },
    productName: {
        fontSize: theme.fontSize.lg,
        lineHeight: theme.lineHeight.tight,
        fontWeight: theme.fontWeight.semibold,
        color: theme.colors.primary800
    },
    productUnderwritten: {
        fontSize: theme.fontSize.xs,
        lineHeight: theme.lineHeight.normal,
        fontWeight: theme.fontWeight.normal,
        color: theme.colors.grey700
    }
}));

// eslint-disable-next-line valid-jsdoc
/**
 * Layout:
 * | -----------  | Product-name          |
 * | Provier-logo | Provider-underwritten |         Compare Pill |
 * | ___________  |       breakline       |
 */
const _ProductSummarySm = (props) => {
    const theme = useContext(ThemeContext);
    const classes = useStyles({ theme });
    const { className, providerCode, productName, productUnderwriterName, productId } = props;

    return (
        <div className={classNames('test-policyProductCard-summary-sm', className, classes.container)}>
            <ProviderLogo className={classes.logo} code={providerCode} />
            <div className={classes.product}>
                <Typography className={classes.productName}>{productName}</Typography>
                <ProductUnderwritten className={classes.productUnderwritten} productUnderwriterName={productUnderwriterName} />
            </div>
            <ComparePill providerCode={providerCode} productId={productId} />
        </div>
    );
};

_ProductSummarySm.propTypes = {
    className: PropTypes.string,
    quote: PropTypes.object,
    productName: PropTypes.string,
    productUnderwriterName: PropTypes.string,
    providerCode: PropTypes.string.isRequired,
    productId: PropTypes.string.isRequired
};

const ProductSummarySm = withQuoteFlatten(_ProductSummarySm);

export { ProductSummarySm };
